import React from 'react';
import { formatExportData } from 'components/atoms/tables/smarttables/helpers/helper';
import CsvDownloader from 'react-csv-downloader';
import { Button, Icon, Dropdown } from 'semantic-ui-react';

const ExportButton = <Button style={{
    height: '38px',
    width: '38px',
    backgroundColor: '#FFF',
    boxShadow: '0 1px 2px 0 rgb(34 36 38 / 15%)',
    border: '1px solid rgba(34,36,38,.15)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '18px'
}} size="big" icon><Icon name="download"></Icon></Button>;

const ExportDropdown = ({ datas, visibleColumns, allColumns, fileName, ...rest }) => (
    <Dropdown {...rest}
        trigger={ExportButton}
        direction='left'
        icon={false}
        floating
    >
        <Dropdown.Menu>
            <Dropdown.Item>
                <CsvDownloader
                    datas={datas}
                    columns={visibleColumns}
                    filename={fileName}>
                    <div>Export Visible Columns</div>
                </CsvDownloader>
            </Dropdown.Item>
            <Dropdown.Item>
                <CsvDownloader
                    datas={datas}
                    columns={allColumns}
                    filename={fileName}>
                    <div>Export All Columns</div>
                </CsvDownloader>
            </Dropdown.Item>
        </Dropdown.Menu>
    </Dropdown>
);

const ExportData = ({ fileName = 'export', tableProps }) => {
    const { dataFromAllRows, allColumnsToExport, visibleColumnsToExport } = formatExportData(tableProps);

    return (
        <ExportDropdown
            datas={dataFromAllRows}
            allColumns={allColumnsToExport}
            visibleColumns={visibleColumnsToExport}
            fileName={fileName}
        />
    );
};
export default ExportData;



// WEBPACK FOOTER //
// ./src/components/atoms/tables/smarttables/tablePlugins/ExportData.js